// extracted by mini-css-extract-plugin
module.exports = {"airPressure":"AirPressure_airPressure__IRxMT"};